import { FaChevronRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';

/**
 * items: [{ label: string, to?: string }]
 * The last item is the current page (not linked).
 */
export default function BillingBreadcrumbs({ items = [] }) {
    if (!items.length) return null;

    return (
        <nav
            aria-label="Billing breadcrumb"
            style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: '6px',
                fontSize: '0.82rem',
                marginBottom: '14px',
                color: 'var(--theme-text-muted)',
            }}
        >
            {items.map((item, idx) => {
                const isLast = idx === items.length - 1;
                return (
                    <span key={`${item.label}-${idx}`} style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                        {idx > 0 && (
                            <FaChevronRight style={{ fontSize: '0.55rem', opacity: 0.7 }} aria-hidden />
                        )}
                        {item.to && !isLast ? (
                            <Link
                                to={item.to}
                                style={{
                                    color: 'var(--theme-text-secondary)',
                                    textDecoration: 'none',
                                    fontWeight: 500,
                                }}
                                onMouseEnter={e => { e.currentTarget.style.textDecoration = 'underline'; }}
                                onMouseLeave={e => { e.currentTarget.style.textDecoration = 'none'; }}
                            >
                                {item.label}
                            </Link>
                        ) : (
                            <span style={{
                                color: isLast ? 'var(--theme-text)' : 'var(--theme-text-secondary)',
                                fontWeight: isLast ? 600 : 500,
                            }}>
                                {item.label}
                            </span>
                        )}
                    </span>
                );
            })}
        </nav>
    );
}
